/**
 * Niche Configuration
 * This file is auto-generated based on the NICHE environment variable
 * Used to replace {{NICHE}} placeholders in locale files
 * 
 * Generated at: 2026-01-27T19:12:14.568Z
 */

// Niche value from environment variable (set at build time)
export const NICHE = 'mature'

export default NICHE
